<template>
    <div class="game-container">
      <div class="game-header">
        <img src="/LOGO_BFG.svg" alt="">
        <span class="time-container">
          <img src="../assets/images/timer.svg" alt="">
          <span>{{finalTime}}</span>
        </span>
      </div>
      <div class="game-main">
        <game-background :loading="loading"></game-background>
        <div class="cards-container" :class="{gameFinished: !playing}" >
            <div v-show="startGame" class="card" v-for="(card, index) in cards" :key="index" :ref="'card'+index" :style="{transform: 'rotate('+card*90+'deg)'}" @click="onClick(index)">
            </div>
        </div>
      </div>
      <div class="countdown" v-if="showCountdown">
        {{timeLeft>0?timeLeft: '¡YA!'}}
      </div>
    </div>
</template>

<script>

import moment from 'moment'
import GameBackground from './game-background'

export default {
  name: 'FlipCardsGame',
  components: {
    GameBackground
  },
  data () {
    return {
      cards: [],
      finalTimeMilliseconds: 0,
      finalTime: '00:00.00',
      interval: null,
      playing: true,
      grid: 4,
      showCountdown: false,
      timeLimit: 60000, // time limit of the game in milliseconds
      loading: true,
      canvas: document.createElement('CANVAS'),
      timeLeft: 3,
      countdownInterval: null,
      startGame: false
    }
  },
  methods: {
    onClick (index) {
      if (this.playing) {
        this.cards[index] = this.cards[index] + 1
        if (!this.checkCards()) {
          clearInterval(this.interval)
          setTimeout(() => {
            this.$emit('game-over', { score: 1, time: this.finalTime, timeMilliseconds: this.finalTimeMilliseconds })
          }, 2000)
        }
      }
    },
    countdown () {
      if (this.timeLeft === 0) {
        clearInterval(this.countdownInterval)
        this.showCountdown = false
        this.startTimer()
      } else {
        this.timeLeft--
      }
    },
    startTimer () {
      this.startGame = true
      this.initialDate = moment()
      this.interval = setInterval(function () {
        if (this.finalTimeMilliseconds >= this.timeLimit) {
          return this.$emit('game-over', { score: 0, time: this.finalTime, timeMilliseconds: this.finalTimeMilliseconds })
        }
        let min, seg, centis
        this.finalDate = moment()
        this.finalTimeMilliseconds = this.finalDate.diff(this.initialDate)
        min = moment.duration(this.finalTimeMilliseconds).minutes()
        seg = moment.duration(this.finalTimeMilliseconds).seconds()
        centis = Math.round(moment.duration(this.finalTimeMilliseconds).milliseconds() / 10)
        this.finalTime = (min >= 10 ? min : '0' + min) + ':' + (seg >= 10 ? seg : '0' + seg) + '.' + (centis >= 10 ? centis : '0' + centis)
      }.bind(this), 10)
    },
    checkCards () {
      const _check = this.cards.find((card) => {
        return !!(card % this.grid)
      })
      this.playing = !!_check
      return !!_check
    },
    getRandom (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    radomGame () {
      const _random = []
      const _grid = this.grid * this.grid
      for (let index = 1; index <= _grid; index++) {
        _random.push(this.getRandom(1, this.grid))
      }
      this.cards = _random

      this.toDataURL(`/examples/BFG-VERANO-IMG${this.getRandom(1, 5)}.jpg`, (dataURL) => {
        this.cards.forEach((c, index) => {
          this.$refs[`card${index}`][0].style.backgroundImage = `url('${dataURL}')`
        })
        this.loading = false
        this.showCountdown = true
        this.$nextTick(function () {
          setTimeout(() => {
            this.countdownInterval = setInterval(this.countdown, 1000)
          }, 100)
        })
      })
    },
    toDataURL (src, callback, outputFormat) {
      const img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = () => {
        // const canvas = document.createElement('CANVAS')
        const ctx = this.canvas.getContext('2d')
        let dataURL
        this.canvas.height = img.naturalHeight
        this.canvas.width = img.naturalWidth
        ctx.drawImage(img, 0, 0)
        dataURL = this.canvas.toDataURL(outputFormat)
        callback(dataURL)
      }
      img.src = src
      if (img.complete || img.complete === undefined) {
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='
        img.src = src
      }
    },
    onReady () {
      console.log('ready')
    }
  },
  mounted () {
    this.loading = true
    this.radomGame()
  }
}
</script>

<style lang="scss" scoped>
 @import "../assets/styles/variables";

     .board-game-indicator {
      height: 50px;
      border-radius: 25px;
      border: 2px solid #ffffff;
      min-width: 140px;
      background-color: rgba(255, 255, 255, 0.5);
      display: flex;
      align-items: center;
      justify-content: space-around;
      span {
        width: 60%;
        text-align: center;
        @include font-game-primary(14px);
        color: #ffffff;
        position: relative;
        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: -6px;
          height: 30px;
          border-right: 1px solid #ffffff;
        }
      }
    }
     $cardMap: (
      401px: 100px,
      801px: 140px,
      1400px: 200px,
    );

    $card: 80px;
    $cardGrid: 4;

    .cards-container{
        position: relative;
        height: $card * $cardGrid;
        width: $card * $cardGrid;
        transition: box-shadow 2s ease-in-out;
        &.gameFinished{
          animation: bounce .5s ease-in-out infinite;
          box-shadow: 0 0 10px rgba(255,255,255, 0.8)
        }
    }

    .card{
        width: $card;
        height: $card;
        background-size: $card * $cardGrid;
        position: absolute;
        transition: all .25s ease-in-out;
        @for $i from 1 through $cardGrid {
             @for $j from 1 through $cardGrid {
                &:nth-child(#{$cardGrid * ($i - 1) + $j}){
                    background-position: -1 * $card * ($i - 1) -1 * $card * ($j - 1);
                    left: $card * ($i - 1);
                    top: $card * ($j - 1)
                }
             }
        }

    }

    @each $size, $cardSize in $cardMap {
      @media screen and (min-width: $size){
        $card: $cardSize;
        .cards-container{
            height: $card * $cardGrid;
            width: $card * $cardGrid;
        }
        .card{
            width: $card;
            height: $card;
            background-size:  $card * $cardGrid;
            @for $i from 1 through $cardGrid {
              @for $j from 1 through $cardGrid {
                &:nth-child(#{$cardGrid * ($i - 1) + $j}){
                    background-position: -1 * $card * ($i - 1) -1 * $card * ($j - 1);
                    left: $card * ($i - 1);
                    top: $card * ($j - 1)
                }
              }
            }
        }
      }
    }

    @keyframes bounce {
      0%{
        transform: scale(1)
      }
      50%{
        transform: scale(1.05)
      }
      100%{
        transform: scale(1)
      }
    }
</style>
